import * as React from 'react';

import Loader from 'components/atoms/Loader';
import routesConfig from 'defs/routes';
import { WithRouterType } from 'types/withRouter';

export type ProgramFeedRedirectViewOriginPropsType = {
	isSequenceLoading: boolean;
	currentDayNumber: number;
};
export type ProgramFeedRedirectViewPropsType = ProgramFeedRedirectViewOriginPropsType & WithRouterType;

export class ProgramFeedRedirectView extends React.Component<ProgramFeedRedirectViewPropsType> {
	public static displayName = 'ProgramFeedRedirectView';

	public componentDidMount() {
		if (!this.props.isSequenceLoading) {
			this.redirectToCurrentDay(this.props);
		}
	}

	public componentDidUpdate(prevProps: ProgramFeedRedirectViewPropsType) {
		if (prevProps.isSequenceLoading && !this.props.isSequenceLoading) {
			this.redirectToCurrentDay(this.props);
		}
	}

	public redirectToCurrentDay({ currentDayNumber, history }: ProgramFeedRedirectViewPropsType) {
		if (currentDayNumber < 1) {
			history.replace(routesConfig.program.recommended.href);
			return;
		}
		history.replace(routesConfig.today.day.href.replace(':day', currentDayNumber.toString()));
	}

	public render() {
		return <Loader />;
	}
}

export default ProgramFeedRedirectView;
